const CANADA_NORMAL = '701';
const CANADA_TOURISTS = '702';
const MEXICO = '737';
const EGYPT= '601';
const TAIWAN= '817';

export class Utils {
    static isCountryCA_N(mpc: string): boolean {
        return mpc === CANADA_NORMAL;
    }
    static isCountryCA_T(mpc: string): boolean {
        return mpc === CANADA_TOURISTS;
    }
    static isCountryMX(mpc: string): boolean {
        return mpc === MEXICO;
    }
    static isCountryEG(mpc: string): boolean {
        return mpc === EGYPT;
    }
    static isCountryTW(mpc: string): boolean {
        return mpc === TAIWAN;
    }
}
  


// WEBPACK FOOTER //
// ./src/app/shared/utils.ts